import { COMPANIAS, type Compania } from "@/componentes/identidad/identidad"
import { LogoSetieca } from "@/componentes/marca/LogoSetieca"

/** La proporción del `viewBox` de `LogoSetieca`. */
const PROPORCION = 600 / 545

/**
 * La marca de la compañía elegida, en borgoña y con su descriptor debajo, como en el
 * manual de identidad. Se mide en milímetros: es tinta sobre papel.
 *
 * ⚠ **Sin el logo vectorial de Trade sale su NOMBRE en texto, no un dibujo.** Inventarle
 * una marca sería imprimir en una carpeta algo que no es suyo. Cuando llegue el vector,
 * se cambia aquí y en ningún otro sitio.
 */
export function MarcaCompania({
  compania = "SETIECA_AGENTES",
  alto,
  descriptor = true,
}: {
  compania?: Compania
  /** Alto del logo en mm. */
  alto: number
  descriptor?: boolean
}) {
  const base = {
    fontFamily: "var(--font-rotulo)",
    fontWeight: 700,
    textTransform: "uppercase",
    color: "var(--impreso-vino)",
    whiteSpace: "nowrap",
  } as const

  if (compania === "SETIECA_TRADE") {
    return (
      <div style={{ ...base, display: "flex", flexDirection: "column", alignItems: "center" }}>
        <span style={{ fontSize: `${alto * 0.36}mm`, fontWeight: 800, lineHeight: 1.05 }}>
          Setieca
        </span>
        <span style={{ fontSize: `${alto * 0.13}mm`, letterSpacing: "0.08em", lineHeight: 1.2 }}>
          {COMPANIAS.SETIECA_TRADE.descriptor}
        </span>
      </div>
    )
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "1mm" }}>
      <LogoSetieca
        titulo="Setieca"
        style={{
          display: "block",
          height: `${alto}mm`,
          width: `${alto * PROPORCION}mm`,
          color: "var(--impreso-vino)",
        }}
      />
      {descriptor ? (
        <span
          style={{
            ...base,
            fontSize: `${Math.max(1.9, alto * 0.13)}mm`,
            letterSpacing: "0.14em",
            lineHeight: 1,
          }}
        >
          {COMPANIAS.SETIECA_AGENTES.descriptor}
        </span>
      ) : null}
    </div>
  )
}
